export default __webpack_public_path__ + "static/media/proposal-arrow-right.2bfea211.svg";